import React from 'react';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const CookingEquipmentForm = ({ formData, errors, onChange }) => {
  const handleCheckboxChange = (name, checked) => {
    onChange({
      target: {
        name,
        value: checked
      }
    });
  };

  const equipmentOptions = [
    {
      name: 'hasStove',
      label: 'Marine Stove',
      description: 'Gas or electric cooktop for boiling and sautéing',
      icon: 'Flame'
    },
    {
      name: 'hasOven',
      label: 'Oven',
      description: 'Baking and roasting capabilities',
      icon: 'CookingPot'
    },
    {
      name: 'hasGrill',
      label: 'Grill',
      description: 'Outdoor grilling on deck or stern',
      icon: 'Beef'
    },
    {
      name: 'hasMicrowave',
      label: 'Microwave',
      description: 'Quick reheating and defrosting',
      icon: 'Zap'
    },
    {
      name: 'hasAirFryer',
      label: 'Air Fryer',
      description: 'Healthier frying with minimal oil',
      icon: 'Wind'
    }
  ];

  const selectedCount = equipmentOptions?.filter(eq => formData?.[eq?.name])?.length;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl md:text-3xl font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>
          Cooking Equipment
        </h2>
        <p className="text-sm md:text-base" style={{ color: 'var(--color-text-secondary)' }}>
          Select available galley equipment to match meal templates
        </p>
      </div>
      <CheckboxGroup 
        label="Available Cooking Equipment" 
        error={errors?.cookingEquipment}
      >
        {equipmentOptions?.map((equipment) => (
          <div key={equipment?.name} className="flex items-start gap-3 p-3 rounded-lg transition-all" style={{ backgroundColor: formData?.[equipment?.name] ? 'var(--color-muted)' : 'transparent' }}>
            <div className="flex-shrink-0 mt-1">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: formData?.[equipment?.name] ? 'var(--color-primary)' : 'var(--color-muted)' }}>
                <Icon 
                  name={equipment?.icon} 
                  size={20} 
                  color={formData?.[equipment?.name] ? 'var(--color-primary-foreground)' : 'var(--color-text-secondary)'}
                />
              </div>
            </div>
            <div className="flex-1">
              <Checkbox
                label={equipment?.label}
                description={equipment?.description}
                checked={formData?.[equipment?.name]}
                onChange={(e) => handleCheckboxChange(equipment?.name, e?.target?.checked)}
              />
            </div>
          </div>
        ))}
      </CheckboxGroup>
      <div className="flex items-center justify-between p-4 rounded-lg" style={{ backgroundColor: 'var(--color-muted)' }}>
        <div className="flex items-center gap-3">
          <Icon name="ChefHat" size={20} color="var(--color-text-secondary)" />
          <span className="text-sm font-medium" style={{ color: 'var(--color-text-primary)' }}>
            Equipment Selected
          </span>
        </div>
        <span className="text-lg font-semibold data-text" style={{ color: 'var(--color-primary)' }}>
          {selectedCount} / {equipmentOptions?.length}
        </span>
      </div>
      {selectedCount === 0 && (
        <div className="flex items-start gap-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-warning)', opacity: 0.1 }}>
          <div className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5" style={{ backgroundColor: 'var(--color-warning)' }}>
            <span className="text-xs font-semibold" style={{ color: 'var(--color-warning-foreground)' }}>!</span>
          </div>
          <p className="text-sm" style={{ color: 'var(--color-text-primary)' }}>
            Select at least one cooking equipment to enable meal planning
          </p>
        </div>
      )}
    </div>
  );
};

export default CookingEquipmentForm;